import {
  Component,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'ds-progress-bar',
  templateUrl: 'ds-progress-bar.component.html',
  styleUrls: ['ds-progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DsProgressBarComponent {
  @Input() percent = 0;
  @Input() compact = false;

  get clampedPercent(): number {
    const value = Number(this.percent) || 0;
    return Math.max(0, Math.min(100, value));
  }
}
